import { Component } from '@angular/core';
import { NgForage } from 'ngforage';
import { SignStickerDetail } from 'src/app/model/sign/sticker/sign-sticker-detail';
import { SignStickerControllerRequestService } from 'src/app/services/api/sign-associations/implementations/sign-sticker-controller-request.service';
import { SignStickerFactory } from 'src/app/services/stock/sign-sticker/factory/sign-sticker-factory';
import { EditAssociationComponent } from '../edit-association.component';

@Component({
  selector: 'sign-sticker-edit',
  templateUrl: '../edit-association.component.html',
  styleUrls: ['../edit-association.component.scss']
})
export class SignStickerEditComponent extends EditAssociationComponent<
  SignStickerDetail
> {
  constructor(
    protected ngForage: NgForage,
    private signStickerFactory: SignStickerFactory,
    private signStickerControllerRequestService: SignStickerControllerRequestService
  ) {
    super(ngForage);
  }

  protected initializeAssociationType(): void {
    this.associationType = 'SignStickerDetail';
  }

  protected initializeAssocObject(): void {
    if (this.assocObject == null) {
      this.assocObject = this.signStickerFactory.createSignSticker();
      this.loading = false;
    } else {
      this.signStickerControllerRequestService
        .getById(this.assocObject.id)
        .then((signSticker: SignStickerDetail) => {
          this.assocObject = signSticker;
          this.loading = false;
        });
    }
  }

  protected getSavePromise(): Promise<SignStickerDetail> {
    return this.assocObject.id == null
      ? this.signStickerControllerRequestService.create(
          this.assocObject,
          this.signId
        )
      : this.signStickerControllerRequestService.update(
          this.assocObject,
          this.signId
        );
  }
}
